RivalIQ.apps.AccountSettings.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            widgetId: widgetTypes.USERS,
            region: 'top',
            action: 'users'
        },
        {
            widgetId: widgetTypes.USER,
            region: 'narrow',
            action: 'user'
        },
        {
            widgetId: widgetTypes.USER_PROFILE_MANAGEMENT,
            region: 'narrow',
            action: 'user'
        },
        {
            widgetId: widgetTypes.RECEIPTS,
            region: 'top',
            action: 'receipts'
        },
        {
            widgetId: widgetTypes.CONNECTED_SERVICES,
            region: 'top',
            action: 'services'
        },
        {
            widgetId: widgetTypes.COMPANY_SUMMARY,
            region: 'top',
            action: 'companies'
        },
        {
            widgetId: widgetTypes.ACCOUNT_COMPANIES,
            region: 'top',
            action: 'companies'
        }
    ];

    const joinFilter = function (curation) {
        const invited = RivalIQ.state.user.isInvited();

        if (invited) {
            return '/account/join/details';
        } else if (!invited && curation.getProp('action') === 'join') {
            return '/account/users';
        }

        RivalIQ.execute('toggle:shell', !invited);
    };

    const permissionFilter = function (curation) {
        if (curation.getProp('action') !== 'user' &&
            !RivalIQ.state.user.can('update', RivalIQ.state.account)) {

            return '/account/user';
        }
    };

    const loadFbTokens = function (curation) {
        if (curation.getProp('action') !== 'services') {
            return;
        }

        const tokens = new RivalIQ.collections.Tokens();
        tokens.channel = RivalIQ.enums.channels.FACEBOOK;
        return tokens.fetch().then(function () {
            curation.tokens = tokens;
        });
    };

    const loadReceipts = function (curation) {
        if (curation.getProp('action') !== 'receipts') {
            return;
        }

        return RivalIQ.data.invoices.fetch().then(function (invoices) {
            const selected = invoices.get(curation.getProp('actionTypeId'));

            if (!selected && curation.isExporting()) {
                throw new Error(`Invoice ${curation.getProp('actionTypeId')} not present in returned invoices for export`);
            }

            if (!selected && invoices.length) {
                return `/account/receipts/${invoices.first().get('id')}`;
            }

            curation.receipt = selected;
            curation.receipts = invoices;
        });
    };

    const Layout = Dashboard.views.Widgets.extend({
        getPanelView: function (child) {
            return (child.detailPanelView || Dashboard.views.Panel);
        }
    });

    const page = RivalIQ.configuration.menus.getConfiguration().ACCOUNT_SETTINGS;

    curations.Account = Dashboard.models.Curation.extend({
        beforeFilters: [
            joinFilter,
            permissionFilter,
            loadReceipts,
            loadFbTokens
        ],

        widgetsView: Layout,
        widgetDefinitions: widgets,

        rejectWidget: function (widget) {
            const me = this;
            return widget.action !== me.getProp('action');
        },

        exportWidgetsView: Dashboard.views.ExportWidgets.extend({
            hideExportTitleBar: true
        }),

        /*
         * Stripe Ids can look like "02172016", which would get automatically
         * parsed to 2172016 by default parameter parsing
         */
        parseParams: _.identity,

        page: page,
        title: page.name,

        companySets: false,
        timePeriod: false
    });

});
